import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { NotificationBarClientComponent } from './bar/client/bar.component';
import { NotificationBarTypeClientTimezoneConflictComponent } from './bar/type/client-timezone-conflict/timezone-conflict.component';
import { NotificationBarTypeClientSpeedupActivationComponent } from './bar/type/client-speedup-activation/client-speedup-activation.component';

import { NotificationService } from './notification.service';
import { SharedModule } from './../../../shared/shared.module';


export class NotificationModule { }



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/shared/notification/notification.module.ts